
import _ from 'lodash'
import ProdFilterHeader from './ProdFilterHeader.vue'
import ProdFilterSection from './ProdFilterSection.vue'
import ProdFilterBubbles from './ProdFilterBubbles.vue'
import { FILTERS } from '@/feature/search/constants'
import { convertIds } from '@/feature/search'
import { isFullRefresh, isSelectedCategory, checkShownProperty, addFilterType } from '@/feature/search/utils'

export default {
  name: 'ProdFilter',
  components: {
    ProdFilterHeader,
    ProdFilterSection,
    ProdFilterBubbles,
  },
  props: {
    gap: {
      type: Boolean,
      default: false
    },
    filterList: {
      type: Array,
      default () {
        return []
      }
    },
    showingTabList: {
      type: Array,
      default () {
        return [
          '카테고리',
          '브랜드별',
          '배송유형',
          '상품유형',
          '별점',
          '가격대',
          // '연령',
        ]
      },
    },
    forceShowingProperty: {
      type: Boolean,
      default () {
        return false
      },
    },
    checkedFilter: {
      type: Array,
      default () {
        return []
      },
    },
  },
  emits: ['changed'],
  setup (_props, { emit }) {
    const fireFilterChanged = (value, refresh) => emit('changed', value, refresh)
    return {
      fireFilterChanged,
    }
  },
  data () {
    return {
      filterCheck: [],
      dialogFormVisible: false,
      folding: {
        category: true,
        properties: true,
        brand: true
      },
      activeNames: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19],
      isShowProperty: false,
    }
  },
  computed: {
    filterSections: function () {
      const {
        category,
        property,
        brand,
        deliveryType,
        goodsType,
        star,
        price,
        age,
      } = FILTERS

      return [
        {
          id: category.id,
          name: category.name,
          data: this._pdMediumCateList,
          limit: 10,
        },
        {
          id: property.id,
          name: property.name,
          data: this._pdPropList,
          limit: 5,
        },
        {
          id: brand.id,
          name: brand.name,
          data: this._pdBrandList,
          limit: 0,
        },
        {
          id: deliveryType.id,
          name: deliveryType.name,
          data: this._pdDvList,
          limit: 0,
        },
        {
          id: goodsType.id,
          name: goodsType.name,
          data: this._pdTypeList,
          limit: 0,
        },
        {
          id: star.id,
          name: star.name,
          data: this._pdRateList,
          limit: 0,
        },
        {
          id: price.id,
          name: price.name,
          data: this._pdPriceList,
          limit: 0,
        },
        {
          id: age.id,
          name: age.name,
          data: this._pdAgeList,
          limit: 0,
        },
      ]
    },
    _filterList: function () {
      return convertIds(this.filterList)
    },
    _pdBrandList: function () {
      return _.flow(
        addFilterType,
      )(this._filterList[0], 'brndCd')
    },
    _pdMajorCateList: function () {
      return _.flow(
        addFilterType,
      )(this._filterList[1], 'lcl_cd')
    },
    _pdMediumCateList: function () {
      return _.flow(
        addFilterType,
      )(this._filterList[2], 'mcl_cd')
    },
    _pdSmallCateList: function () {
      return _.flow(
        addFilterType,
      )(this._filterList[3], 'scl_cd')
    },
    _pdDvList: function () {
      const dv = _.flow(
        addFilterType,
      )(this._filterList[4], 'dvrTy')

      return _.map(dv, ({ name, ...rest }) => ({
        ...rest,
        name: name === '대량배송' ? '대량주문' : name,
      }))
    },
    _pdTypeList: function () {
      return _.flow(
        addFilterType,
      )(this._filterList[5], 'goodsType')
    },
    _pdPropList: function () {
      return _.flow(
        addFilterType,
      )(this._filterList[6], 'attrItemCd')
    },
    _pdRateList: function () {
      return _.flow(
        addFilterType,
      )(this._filterList[7], 'revwStsc')
    },
    _pdPriceList: function () {
      return _.flow(
        addFilterType,
      )(this._filterList[8], 'pdPrcRange')
    },
    _pdAgeList: function () {
      return _.flow(
        addFilterType,
      )(this._filterList[9], 'tOrdr')
    },
    categoryData: function () {
      return {
        data: {
          major: this._pdMajorCateList,
          medium: this._pdMediumCateList,
          small: this._pdSmallCateList,
        }
      }
    },
    propertyData: function () {
      return _.map(this._pdPropList, ({
        id: propId,
        kind,
        name,
        value,
        subGroup,
      }) => ({
        id: propId,
        label: kind || name, // `${name} ${kind}`,
        children: _
          .map(subGroup, ({ id: subId, ...sub }) => ({
            id: subId,
            type: 'attrItemCd',
            ...sub
          }))
          .sort((a, b) => {
            const aNum = this.idToNum(a.id)
            const bNum = this.idToNum(b.id)
            const comp = aNum - bNum
            return aNum === 1 ? 1 : bNum === 1 ? -1 : comp
          }),
        count: value,
      }))
    },
  },
  created () {
    this.constants = {
      filters: FILTERS
    }
    const filters = sessionStorage.getItem('filterCheck')
    if (filters !== null && filters !== '') {
      this.filterCheck = JSON.parse(filters)
      if (this.filterCheck !== null) {
        this.filterCheck.filter((item, index, self) =>
          index === self.findIndex(
            t => t.id === item.id && t.type === item.type
          )
        )
      }
    }
    console.log('Initial Load :: ', this.$route.path)
  },
  methods: {
    idToNum: strId => _.chain(strId).split('_').last().toNumber().value(),
    tabFilter (sectionName, sectionData) {
      let result = false

      if (_.size(sectionData) === 0) {
        return false
      }

      switch (sectionName) {
        case '속성':
          result = this.forceShowingProperty || (_.includes(this.showingTabList, '카테고리') && this.isShowProperty)
          break
        default:
          result = _.includes(this.showingTabList, sectionName)
          break
      }
      return result
    },
    isCategory: id => id === FILTERS.category.id,
    isProperty: id => id === FILTERS.property.id,
    handleFilterChanged (checkedList) {
      this.isShowProperty = checkShownProperty(checkedList)
      this.filterCheck = checkedList
      const uniqueCheckedList = this.filterCheck.filter((item, index, self) => index === self.findIndex(t => t.id === item.id && t.type === item.type))
      sessionStorage.setItem('filterCheck', JSON.stringify(uniqueCheckedList)) // [DEV-5156] 로컬 스토리지에 필터 체크 한 내용 담아두기
      this.fireFilterChanged(this.filterCheck, isFullRefresh(this.filterCheck))
    },
    resetFilterChecked () {
      this.handleFilterChanged([])
    },
    filterDelete (item) {
      const checked = isSelectedCategory(item)
        ? [] // 카테고리 선택시 리셋
        : _.filter(
          this.filterCheck,
          bubble => bubble.name !== item.name
        )
      this.handleFilterChanged(checked, _.size(checked) === 0)
    },
  },
}
